import React, { useState, useEffect } from "react";
import { Button } from "antd";
import { useNavigate } from "react-router-dom";
import alternative from "../../assets/images/alternative.png";

// ✏️ Элсэлт эхлэх огноо
const DEADLINE = new Date("2026-02-26T14:26:00");

const pad = (n) => String(n).padStart(2, "0");

const calculateTimeLeft = () => {
    const diff = DEADLINE - new Date();
    if (diff <= 0) return null;
    return {
        days: Math.floor(diff / (1000 * 60 * 60 * 24)),
        hours: Math.floor((diff / (1000 * 60 * 60)) % 24),
        minutes: Math.floor((diff / (1000 * 60)) % 60),
        seconds: Math.floor((diff / 1000) % 60),
    };
};

const TimeUnit = ({ value, label }) => (
    <div className="flex flex-col items-center">
        <div
            className="
        relative flex items-center justify-center
        w-20 h-20 md:w-28 md:h-28
        rounded-2xl
        bg-white shadow-lg
        border border-purple-100
        overflow-hidden
      "
        >
            {/* subtle top shine */}
            <div className="absolute top-0 left-0 right-0 h-1/2 bg-gradient-to-b from-white/60 to-transparent pointer-events-none" />
            <span
                className="
          text-3xl md:text-5xl font-bold tracking-tight
          text-transparent bg-clip-text
          bg-gradient-to-b from-[#7c3aed] to-[#5c1090]
          font-raleway
          z-10
        "
            >
                {pad(value)}
            </span>
        </div>
        <span className="mt-2 text-xs md:text-sm font-semibold text-gray-500 uppercase tracking-widest font-raleway">
            {label}
        </span>
    </div>
);

const Separator = () => (
    <span className="text-3xl md:text-5xl font-bold text-[#5c1090] pb-6 select-none">
        :
    </span>
);

const CountdownPage = () => {
    const [timeLeft, setTimeLeft] = useState(calculateTimeLeft());
    const navigate = useNavigate();

    useEffect(() => {
        const timer = setInterval(() => {
            setTimeLeft(calculateTimeLeft());
        }, 1000);
        return () => clearInterval(timer);
    }, []);

    const isExpired = !timeLeft;

    return (
        <div
            className="
        relative flex flex-col items-center justify-center
        min-h-screen p-8
        bg-gradient-to-br from-[#f3eeff] via-white to-[#ede9fe]
        font-raleway overflow-hidden
      "
        >
            {/* Decorative blobs */}
            <div className="absolute top-[-80px] left-[-80px] w-72 h-72 bg-purple-200 rounded-full opacity-30 blur-3xl pointer-events-none" />
            <div className="absolute bottom-[-60px] right-[-60px] w-64 h-64 bg-indigo-200 rounded-full opacity-30 blur-3xl pointer-events-none" />

            {/* Logo */}
            <img
                src={alternative}
                alt="Томүжин Алтернатив Сургууль"
                className="w-48 md:w-64 object-contain mb-8 drop-shadow-sm"
            />

            {/* Heading */}
            <h1 className="text-2xl md:text-4xl font-bold text-[#5c1090] text-center leading-tight mb-2">
                {isExpired ? "Элсэлт нээгдлээ!" : "Элсэлт эхлэх хүртэл"}
            </h1>
            <p className="text-gray-500 text-sm md:text-base text-center mb-10 max-w-md">
                {isExpired
                    ? "Элсэлт нээлттэй боллоо!"
                    : `Элсэлт эхлэх огноо: ${DEADLINE.toLocaleDateString("mn-MN", {
                        year: "numeric",
                        month: "numeric",
                        day: "numeric",
                    })}`}
            </p>

            {/* Countdown tiles */}
            {!isExpired ? (
                <div className="flex items-end gap-3 md:gap-5 mb-12">
                    <TimeUnit value={timeLeft.days} label="Өдөр" />
                    <Separator />
                    <TimeUnit value={timeLeft.hours} label="Цаг" />
                    <Separator />
                    <TimeUnit value={timeLeft.minutes} label="Минут" />
                    <Separator />
                    <TimeUnit value={timeLeft.seconds} label="Секунд" />
                </div>
            ) : (
                <div className="mb-12 text-6xl">🎓</div>
            )}

            {/* Progress bar */}
            {!isExpired && (() => {
                const total = DEADLINE - new Date("2026-01-01T00:00:00");
                const elapsed = new Date() - new Date("2025-01-01T00:00:00");
                const pct = Math.min(100, Math.max(0, (elapsed / total) * 100));
                return (
                    <div className="w-full max-w-sm mb-10">
                        <div className="flex justify-between text-xs text-gray-400 mb-1">
                            <span>Эхлэл</span>
                            <span>{pct.toFixed(0)}% өнгөрсөн</span>
                            <span>Дуусгавар</span>
                        </div>
                        <div className="h-2 bg-purple-100 rounded-full overflow-hidden">
                            <div
                                className="h-full rounded-full bg-gradient-to-r from-[#7c3aed] to-[#5c1090] transition-all duration-1000"
                                style={{ width: `${pct}%` }}
                            />
                        </div>
                    </div>
                );
            })()}

            {/* CTA */}
            <Button
                type="primary"
                size="large"
                className="px-10 font-raleway font-semibold"
                onClick={() => navigate("/application")}
                disabled={!isExpired}
            >
                {isExpired ? "Өргөдөл гаргах" : "Удахгүй нээгдэнэ..."}
            </Button>

            {/* Footer note */}
            <p className="mt-8 text-xs text-gray-400 text-center">
                Өргөдлийн хураамж: <strong className="text-[#5c1090]">60,000₮</strong>
            </p>
        </div>
    );
};

export default CountdownPage;